import { Component, OnInit, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'crm-prospect-create-progress-dialog',
  templateUrl: './prospect-create-progress-dialog.component.html',
  styleUrls: ['./prospect-create-progress-dialog.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProspectCreateProgressDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<ProspectCreateProgressDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string }
  ) {}

  ngOnInit() {}
}
